/* eslint-disable no-nested-ternary */
import {IFilterFacet} from 'plugins/modules/filter/types';
import React, {FC, useMemo} from 'react';
import {AppliedFilterSingleItem} from 'plugins/modules/filter/components/AppliedFilterSingleItem';
import {getLocaleNumber} from 'core/helpers';
import {isPriceFilterByUnit} from 'plugins/modules/filter/helpers';

interface IProps {
    onClear: () => void;
    filter: IFilterFacet;
}

export const AppliedRangeFilterController: FC<IProps> = ({onClear, filter}) => {
    const isPriceFilter = useMemo(() => isPriceFilterByUnit(filter.unit), [filter.unit]);

    const title = useMemo(() => {
        const {maxValue, minValue, unit} = filter;

        const min = isPriceFilter ? getLocaleNumber(minValue, unit) : minValue ? `${minValue} ${unit}` : '';
        const max = isPriceFilter ? getLocaleNumber(maxValue, unit) : maxValue ? `${maxValue} ${unit}` : '';

        if (!min && !max) {
            return '';
        }

        if (min && max) {
            return `${min} - ${max}`;
        }

        if (min) {
            return `от ${min}`;
        }

        return `до ${max}`;
    }, [filter, isPriceFilter]);

    if (!title) {
        return null;
    }

    return <AppliedFilterSingleItem onClear={onClear} title={title} data-skeleton-item={true} />;
};
